import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const $auth = inject(AuthService);
  const $router = inject(Router);

  if (!$auth.getAuthToken()) {
    $router.navigate(['/', 'redirect']);
    return false;
  }

  const loaded = await $auth.isUserDataLoaded();
  if ($auth.hasExpiredPassword()) {
    return false;
  }

  return loaded && !!$auth.getAuthToken();
};
